import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Banner.css';

const Banner = ({ title, image }) => {
  return (
    <div className="banner-wrapper" style={{ backgroundImage: `url(${image})` }}>
      <div className="banner-overlay">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="container"
        >
          <h1 className="banner-title">{title}</h1>
        </motion.div>
      </div>
    </div>
  );
};

export default Banner;
